/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // クイック追加(商品カードのかごボタン/カートに追加する)は、PC・スマホとも
  // カート追加後にドロワーを自動で開かない。テーマ側 openCartDrawerOnProductAdded
  // がこのフラグを参照して抑止する(assets/theme.js 側に対応パッチあり)。
  // 商品詳細ページの「カートに追加する」とカートアイコンは従来どおりドロワーを開く。
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (btn && btn.closest('[data-quick-add-holder]')) {
      window.__ngoQuickAddSuppress = Date.now();
    }
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ===== NGO HERO SPARKLE : BEGIN =====================================
   ヒーロー画像をタップすると小さなスパークルが3〜5個ポンと弾ける。
   イラスト本体には触れず、画面座標に重ねたレイヤーへ描くだけ。
   ロールバックは BEGIN〜END の範囲を削除するだけでよい。
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var CONFIG = {
    // 'press' : ヒーローがリンクのまま。押下の手応えとして光るだけで遷移は妨げない(既定)
    // 'play'  : ヒーローの遷移を止め、何度でも弾けるイースターエッグにする
    mode: 'press',
    selector: '.index-hero.slideshow',
    countMin: 6,
    countMax: 8,
    cooldown: 350,     // 連打で画面が埋まるのを防ぐ
    maxLive: 32,       // 同時生存数の上限。1回8個 × 連打3回ぶんを見込んだ値。drop-shadow を使うので必ず効かせる
    sizeMin: 18,
    sizeMax: 32,
    spreadMin: 57,     // 飛距離(px)。大きくすると一気に「うるさい」側へ振れる
    spreadMax: 126,
    gravity: 26,       // 終点を下へ流す量。ふわっと落ちる見え方になる
    durMin: 749,
    durMax: 1040,
    // サイト既存のネオン配色。「にぎやか」設定に合わせてピンクを厚めに置いている。
    // 落ち着かせたいときは '#ffffff' の比率を上げるのが一番効く。
    colors: ['#ffffff', '#ff2e9a', '#ff2e9a', '#ffc2e2', '#4fd8ff'],
    hint: true,        // 初回表示時に一度だけ自動で光らせ「押せる」ことを伝える
    hintDelay: 1700
  };

  if (window.__ngoSparkleInit) return;
  window.__ngoSparkleInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;

  var SVG =
    '<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M50 1c3.2 28.6 20.4 45.8 49 49-28.6 3.2-45.8 20.4-49 49-3.2-28.6-20.4-45.8-49-49 28.6-3.2 45.8-20.4 49-49z"/>' +
    '</svg>';

  var layer = null;
  var live = 0;
  var lastAt = 0;

  function getLayer() {
    if (layer && layer.isConnected) return layer;
    layer = document.createElement('div');
    layer.className = 'ngo-sparkle-layer';
    document.body.appendChild(layer);
    return layer;
  }

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function spawn(x, y, count, scale) {
    var host = getLayer();
    var n = Math.min(count, CONFIG.maxLive - live);
    if (n <= 0) return;

    // 上半円を厚めに使う。真下に飛ぶ粒が多いと「散らかった」印象になる。
    var base = rand(0, Math.PI * 2);

    for (var i = 0; i < n; i++) {
      var angle = base + (Math.PI * 2 / n) * i + rand(-0.35, 0.35);
      var dist = rand(CONFIG.spreadMin, CONFIG.spreadMax) * scale;
      var size = rand(CONFIG.sizeMin, CONFIG.sizeMax) * scale;
      var color = CONFIG.colors[(Math.random() * CONFIG.colors.length) | 0];

      var el = document.createElement('span');
      el.className = 'ngo-sparkle';
      el.innerHTML = SVG;
      el.style.left = x + 'px';
      el.style.top = y + 'px';
      el.style.color = color;
      el.style.setProperty('--s', size.toFixed(1) + 'px');
      el.style.setProperty('--tx', (Math.cos(angle) * dist).toFixed(1) + 'px');
      el.style.setProperty('--ty', (Math.sin(angle) * dist + CONFIG.gravity).toFixed(1) + 'px');
      el.style.setProperty('--rot', rand(-140, 140).toFixed(0) + 'deg');
      el.style.setProperty('--dur', rand(CONFIG.durMin, CONFIG.durMax).toFixed(0) + 'ms');
      el.style.setProperty('--delay', rand(0, 90).toFixed(0) + 'ms');
      el.style.setProperty('--glow', color === '#ffffff' ? 'rgba(255,255,255,.95)' : color);

      live++;
      el.addEventListener('animationend', function () {
        live--;
        if (this.parentNode) this.parentNode.removeChild(this);
      });
      // アニメーションが走らなかった場合の保険(タブ非表示など)
      setTimeout(function () {
        if (el.parentNode) { live--; el.parentNode.removeChild(el); }
      }, 2000);

      host.appendChild(el);
    }
  }

  // 矢印・ドット・CTAボタンの上では出さない。操作対象がぼやける。
  function isControl(node) {
    return !!(node.closest('.flickity-button, .flickity-page-dots, button, .btn, [role="button"]'));
  }

  function onPress(e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var hero = target.closest(CONFIG.selector);
    if (!hero || isControl(target)) return;

    var now = Date.now();
    if (now - lastAt < CONFIG.cooldown) return;
    lastAt = now;

    var x = (e.clientX != null) ? e.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
    var y = (e.clientY != null) ? e.clientY : (e.touches && e.touches[0] ? e.touches[0].clientY : 0);

    spawn(x, y, (CONFIG.countMin + Math.round(Math.random() * (CONFIG.countMax - CONFIG.countMin))), 1);

    var img = target.closest('.hero__image') || hero;
    img.classList.add('ngo-sparkle-press');
    setTimeout(function () { img.classList.remove('ngo-sparkle-press'); }, 140);
  }

  if (window.PointerEvent) {
    document.addEventListener('pointerdown', onPress, { passive: true });
  } else {
    document.addEventListener('touchstart', onPress, { passive: true });
    document.addEventListener('mousedown', onPress, { passive: true });
  }

  // play モードのときだけヒーローの遷移を止める。press モードでは何もしない。
  document.addEventListener('click', function (e) {
    if (CONFIG.mode !== 'play') return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(CONFIG.selector) && !isControl(t)) e.preventDefault();
  });

  // 初回だけ、ヒーローが見えたタイミングで一度そっと光らせる。
  // 「押せる」ことに気づかせるためのもので、ループはさせない。
  function hint() {
    if (!CONFIG.hint) return;
    try {
      if (sessionStorage.getItem('ngoSparkleHint')) return;
      sessionStorage.setItem('ngoSparkleHint', '1');
    } catch (err) { /* プライベートモード等では単にヒントを出す */ }

    var hero = document.querySelector(CONFIG.selector);
    if (!hero) return;

    setTimeout(function () {
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      spawn(r.left + r.width * 0.5, r.top + r.height * 0.42, 3, 0.8);
    }, CONFIG.hintDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hint);
  } else {
    hint();
  }
})();
/* ===== NGO HERO SPARKLE : END ======================================= */
